import { type FC, useEffect, useRef, useState } from 'react';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';
import { trackSoldPdpSponsoredYmalGridTest } from '../../utils/abTestHelper.ts';
import { usePdpRespSimilarSponsoredItemsContext } from './PdpRespSimilarSponsoredItemsContext.tsx';

/*
 * Sold PDP YMAL AB exposure. Fires once the grid is visible and the SL
 * pool is large enough (both arms). Eligibility arrives after first
 * visibility.
 */

export const PdpSoldYmalGridAbExposureTracker: FC = () => {
    const hasTrackedRef = useRef(false);
    const [isGridVisible, setIsGridVisible] = useState(false);
    const { isEligibleForAbTracking } = usePdpRespSimilarSponsoredItemsContext();

    useEffect(() => {
        if (hasTrackedRef.current || !isGridVisible || !isEligibleForAbTracking) {
            return;
        }
        hasTrackedRef.current = true;
        trackSoldPdpSponsoredYmalGridTest();
    }, [isGridVisible, isEligibleForAbTracking]);

    return (
        <VisibilityTracker
            onVisibilityChange={({ isVisible }) => {
                if (isVisible) {
                    setIsGridVisible(true);
                }
            }}
        />
    );
};
